import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import "../../../css/styles.css";
import SavingsChangeConfirmCard from './savings_change_confirm_card';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import WaitTimeSpinner from '../../shared-components/wait_time_spinner';
import buildConfirmModalContent from './objects/build_confirm_modal_content';
import SavingsChangeConfirmCDList from './savings_change_confirm_CD_list';

class SavingsChangeConfirmModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                 waitTimer: false,
              } 
        this.determineTotalAmounts();
        this.determineModalText();
    }

    determineTotalAmounts(){
        this.confirmArr = [];
        const savingsInfoArr = JSON.parse(JSON.stringify(this.props.savingsInfoArr));
        const confirmModalContent = buildConfirmModalContent(savingsInfoArr, 
                this.props.CDList );
        this.confirmArr = confirmModalContent.confirmArr;
        this.displayCDList = false;
        this.CDListArr = confirmModalContent.CDListArr;
        this.transferFeeSw = confirmModalContent.transferFeeSw;
        if (this.CDListArr.length > 0){
            this.displayCDList = true;
        }
        let totalNewMonthlyAmt = confirmModalContent.totalNewMonthlyAmt;
        this.determineArrPercent(totalNewMonthlyAmt);
    }

    determineArrPercent(totalNewMonthlyAmt){
        for (let i=0; i<this.confirmArr.length; i++){
            let monthlyAmt = this.confirmArr[i].currentMonthlyAmt;
            if (this.confirmArr[i].newMonthlyAmt){
                monthlyAmt = this.confirmArr[i].newMonthlyAmt;
            }
            let percent = 0;
            if (totalNewMonthlyAmt > 0){
                percent = monthlyAmt / totalNewMonthlyAmt;
            }
            percent = (percent * 100).toFixed(0);
            this.confirmArr[i].percent = percent;
        }
    }

    determineModalText(){
        if (this.props.savingsClass === "bank"){
            this.modalHeader = "Confirm Changes to Bank Accounts";
        }else{
            this.modalHeader = "Confirm Changes to Retirement 401(k) Accounts";
        }
       
    }

    render() {
         this.savingsAmounts = this.confirmArr.map((savingInfoAmts, index) =>
            <SavingsChangeConfirmCard key={index} tableInfo={savingInfoAmts} 
                />
            );  
        this.CDListChanges = this.CDListArr.map((CDList, index) =>
            <SavingsChangeConfirmCDList key={index} tableInfo={CDList}
                />    
            );
    return <>  
      <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="lg" scrollable="true"
            dialogClassName="modal-with-rounded-corners" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
          <Modal.Title className="text-center">{this.modalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div >
                <div className="row mx-4">
                    <div className="col-sm-6">
                        <span className="font-weight-bold">Current Cash:</span>
                        <span className="ml-4">{doubleToStringMonthly(this.props.currentCash)}</span>
                    </div>
                    <div className="col-sm-6">
                        <span className="font-weight-bold">Monthly Income:</span>
                        <span className="ml-4">{doubleToStringMonthly(this.props.monthlyIncome)}</span>
                    </div>
                </div>
                
                <div >
                    <h5 className="text-center mt-4">
                        Changes have been made to accounts that are highlighted below.
                    </h5>
                    <table className="table table-hover table-no-space">
                        <tbody>
                            <tr>
                                <th className="text-center"></th>
                                <th className="text-center" colSpan="2">---One-Time Amounts---</th>
                                <th className="text-center" colSpan="3">---Monthly Amounts---</th>
                            </tr>
                            <tr>
                                <th className="text-center">Savings Type</th>
                                <th className="text-right">Deposit</th>
                                <th className="text-right">Withdrawal</th>
                                <th className="text-right">Current Amt</th>
                                <th className="text-right">New Amt</th>
                                <th className="text-center">Percent</th>
                            </tr>
                            {this.savingsAmounts}  
                        </tbody>
                    </table>
                    {this.transferFeeSw  ?
                        <div className="font-weight=bold">
                            ***Fee for early withdrawal will reduce the amount added back to cash.
                        </div>
                    :
                        null
                    }
                    {this.displayCDList   ?
                        <>
                            <h5 className="mt-4 text-center">
                                Changes have been made to the AutoRollover Value for the Following CDs
                            </h5>
                             <table className="table table-hover table-no-space">
                                <tbody>
                                    <tr>
                                        <th className="text-center">Maturity Date</th>
                                        <th className="text-right">Total Amount</th>
                                        <th className="text-right">Current AutoRollover</th>
                                        <th className="text-right">New AutoRollover</th>
                                    </tr>
                                    {this.CDListChanges}
                                </tbody>
                            </table>
                        </>
                    :
                        null
                    }

                </div>
                {this.state.waitTimer  ?
                    <WaitTimeSpinner/>
                :
                    null
                }
            </div>
        </Modal.Body>
         <Modal.Footer className="backgroundTopBottom">
            <Button variant="secondary"  onClick={() => this.entriesConfirmed()}>
                Confirm Changes
            </Button>
            <Button variant="primary"  onClick={() => this.props.onClose()}>
                Back/Close
            </Button>
        </Modal.Footer>
        </Modal>
        
        </>
    }

entriesConfirmed(){
    this.setState({waitTimer: true});
    this.props.onConfirm();
}

    
}

export default SavingsChangeConfirmModal;